import { MemberRecipient, type ConversationAttachment, type AppEnv, type Recipient } from "@/models";
import type { InjectionKey } from "vue";
import defaultProfilePhoto from '@/assets/placeholders/placeHolder_profile.webp'

export class UrlHelper {
  private readonly environment: AppEnv

  constructor(environment: AppEnv) {
    this.environment = environment
  }

  defaultProfilePicture() {
    return defaultProfilePhoto
  }

  concatUrl() {

  }

  memberProfilePicture(memberId: number, photoId?: string) {
    if (!photoId)
      return this.defaultProfilePicture()

    return this.environment.VITE_API_URL + `/api/files/member/${memberId}/profile-picture/${photoId}`
  }

  postFile(messageId: number, fileName: string) {
    return this.environment.VITE_API_URL + `/api/files/post/${messageId}/${fileName}`
  }

  recipientProfilePicture(recipient: Recipient) {
    if (recipient instanceof MemberRecipient) {
      return this.memberProfilePicture(recipient.memberId, recipient.memberPhotoId)
    }

    return this.defaultProfilePicture()
  }

  conversationAttachment(conversationId: number, attachment: ConversationAttachment) {
    return this.environment.VITE_API_URL + `/api/files/thread/${conversationId}/attachment/${attachment.uploadId}?fileName=${encodeURIComponent(attachment.fileName)}`
  }
}

export const URL_HELPER = Symbol() as InjectionKey<UrlHelper>
